import { Breadcrumb } from '@tripointe/tripointe-cms/types';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { delay, filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BreadcrumbsService {
  primaryBreadcrumbs$: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject([]);
  secondaryBreadcrumbs$: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject([]);
  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor() {
    this.breadcrumbs$ = combineLatest([
      this.primaryBreadcrumbs$.asObservable(),
      this.secondaryBreadcrumbs$.asObservable()
    ]).pipe(
      filter(([primaryCrumbs, secondaryCrumbs]) => !!primaryCrumbs && !!secondaryCrumbs),
      map(([primaryCrumbs, secondaryCrumbs]) => [...primaryCrumbs, ...secondaryCrumbs]),
      delay(0)
    );
  }

  setPrimaryBreadcrumbs(value: Breadcrumb[]): void {
    this.primaryBreadcrumbs$.next(value);
  }

  setSecondaryBreadcrumbs(value: Breadcrumb[]): void {
    this.secondaryBreadcrumbs$.next(value);
  }

  clearPrimaryBreadcrumbs(): void {
    this.primaryBreadcrumbs$.next([]);
  }

  clearSecondaryBreadcrumbs(): void {
    this.secondaryBreadcrumbs$.next([]);
  }
}
